import { Text, TextProps } from '@chakra-ui/react'

export type ChartSubtitleProps = TextProps & {
  children?: React.ReactNode
}

export const ChartSubtitle = ({ children, ...props }: ChartSubtitleProps) => (
  <Text fontWeight={500} fontSize="12px" {...props}>
    {children}
  </Text>
)
